<template>
  <div id="app">
    <div class="wrap">
      <h2>身長比較したったーテスト版</h2>
      <div class="msg">
        サーバー「いっぱいアクセスありますね！課金加えます！」
        <br />サーバー「いっぱいアクセスありますね！課金加えます！」
        <br />サーバー「いっぱいアクセスありますね！課金加えます！」
        <p>(｀；ω；´) 移転しました↓</p>
      </div>
      <p>
        <a href="https://hikaku-sitatter.com/" class="btn-iten" target="_self">身長の比較を開始する</a>
      </p>
    </div>
  </div>
</template>

<style lang="scss">
html {
  touch-action: manipulation;
  font-family: "Hiragino Kaku Gothic Pro", "ヒラギノ角ゴ Pro W3", "メイリオ",
    "メイリオ", "ＭＳ Ｐゴシック", sans-serif;
  overscroll-behavior: none;
}
html,
body,
#app {
  height: 100%;
}
#app {
  color: #333;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.wrap {
  margin-top: -15%;
}
.msg {
  font-size: 12px;
  color: #ccc;
}
.btn-iten {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  height: 60px;
  width: 260px;
  background: cornflowerblue;
  color: white;
  font-weight: bold;
  border-radius: 5px;
  text-decoration: none;
  transition: all 0.3s;
  &:hover {
    opacity: 0.8;
  }
}
</style>

<script>
//import HelloWorld from "./components/HelloWorld.vue";

export default {
  name: "App",
  components: {
    //HelloWorld
  }
};
</script>
